import { Grid, styled } from '@mui/material';
import React from 'react';
import { FactboxText } from '../common/utils';
import { TwoColumnFactboxSection } from './two-column-factbox-types';

const TwoColumnTitle = styled(FactboxText)`
  font-size: 1em;
  white-space: normal;
  max-width: 100%;
`;

const TwoColumnMainValue = styled(FactboxText)`
  font-size: 1.5em;
  white-space: normal;
  max-width: 100%;
`;

const TwoColumnSubValue = styled(FactboxText)`
  font-size: 0.8em;
  white-space: normal;
  max-width: 100%;
`;

// Two column section component
export const TwoColumnSection = ({
  section,
}: {
  section: TwoColumnFactboxSection;
}) => {
  return (
    <Grid
      item
      container
      direction={'column'}
      justifyContent={'space-between'}
      wrap="nowrap"
      sx={{ height: '100%' }}
    >
      <Grid
        item
        container
        justifyContent={'center'}
        sx={{ overflow: 'hidden', width: '100%' }}
      >
        {section.title ? (
          <TwoColumnTitle>{section.title}</TwoColumnTitle>
        ) : null}
      </Grid>
      <Grid
        item
        container
        direction={'column'}
        justifyContent="center"
        sx={{ flexGrow: 1, width: '100%' }}
      >
        {section.mainValue !== undefined && (
          <Grid
            item
            container
            justifyContent={'center'}
            sx={{ overflow: 'hidden', width: '100%' }}
          >
            <TwoColumnMainValue>{section.mainValue ?? '-'}</TwoColumnMainValue>
          </Grid>
        )}
        {section.subValues && section.subValues.length > 0 ? (
          <Grid item container direction={'column'} sx={{ width: '100%' }}>
            {section.subValues.map((subValue, i) => (
              <Grid
                key={`${subValue.title}-${i}`}
                item
                container
                direction={'column'}
                alignItems={'center'}
                wrap={'wrap'}
                sx={{ width: '100%' }}
              >
                <Grid
                  item
                  container
                  direction="column"
                  alignItems={'center'}
                  sx={{ overflow: 'hidden', width: '100%' }}
                >
                  <TwoColumnSubValue>{subValue.title}</TwoColumnSubValue>
                  <TwoColumnSubValue sx={{ flexShrink: 0 }}>
                    {subValue.value}
                  </TwoColumnSubValue>
                </Grid>
              </Grid>
            ))}
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
